export const getCartToken = (carts: any, channelName: string) => {
    const { token } =
    carts?.find(({ channel }: { channel: string }) => channel === channelName) || {};
    
    return token;
};
